import React from 'react';

type Severity = 'Critical' | 'High' | 'Medium' | 'Low';

const severityConfig: Record<Severity, { bg: string; text: string; dot: string }> = {
  Critical: { bg: 'bg-severity-critical', text: 'severity-critical', dot: 'bg-danger' },
  High: { bg: 'bg-severity-high', text: 'severity-high', dot: 'bg-orange-500' },
  Medium: { bg: 'bg-severity-medium', text: 'severity-medium', dot: 'bg-warning' },
  Low: { bg: 'bg-severity-low', text: 'severity-low', dot: 'bg-primary' },
};

interface SeverityBadgeProps {
  severity: Severity;
  size?: 'sm' | 'md';
}

export default function SeverityBadge({ severity, size = 'md' }: SeverityBadgeProps) {
  const config = severityConfig[severity];
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-medium
      ${size === 'sm' ? 'px-1.5 py-0.5 text-2xs' : 'px-2 py-0.5 text-xs'}
      ${config.bg} ${config.text}`}>
      <span className={`w-1 h-1 rounded-full ${config.dot}`} />
      {severity}
    </span>
  );
}